export const ProfessionTypeEnum = Object.freeze({
  IT_Development: 0,
  Business_Administration: 1,
  Operations: 2,
  Finance: 3,
  Quality_SixSigma: 4,
  Human_Resources: 5,
  Marketing_Sales: 6,
  SupplyChain_Logistics: 7,
  Education: 8,
  Healthcare: 9,
  Engineering: 10,
  Creative_Design: 11,
  CustomerService: 12,
  Other: 13,
});

export const ProfessionTypeLabel = Object.freeze({
  [ProfessionTypeEnum.IT_Development]: "IT & Development",
  [ProfessionTypeEnum.Business_Administration]: "Business Administration",
  [ProfessionTypeEnum.Operations]: "Operations",
  [ProfessionTypeEnum.Finance]: "Finance",
  [ProfessionTypeEnum.Quality_SixSigma]: "Quality / Six Sigma",
  [ProfessionTypeEnum.Human_Resources]: "Human Resources",
  [ProfessionTypeEnum.Marketing_Sales]: "Marketing / Sales",
  [ProfessionTypeEnum.SupplyChain_Logistics]: "Supply Chain / Logistics",
  [ProfessionTypeEnum.Education]: "Education",
  [ProfessionTypeEnum.Healthcare]: "Healthcare",
  [ProfessionTypeEnum.Engineering]: "Engineering",
  [ProfessionTypeEnum.Creative_Design]: "Creative / Design",
  [ProfessionTypeEnum.CustomerService]: "Customer Service",
  [ProfessionTypeEnum.Other]: "Other",
});

// Helper to get list
export const getProfessionTypeList = () =>
  Object.values(ProfessionTypeEnum).map((value) => ({
    value,
    label: ProfessionTypeLabel[value],
  }));
